import { useCallback, useState } from 'react';

import { Button, ModalBase, ModalBody, ModalFooter, ModalHeader, u } from '@ui';

type ConfirmModalProps = {
    title: string;
    message: string;
    onAccept: () => void;
    onCancel: () => void;
};

export const ConfirmModal = ({ title, message, onAccept, onCancel }: ConfirmModalProps) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleAccept = useCallback(() => {
        setIsLoading(true);
        onAccept();
    }, [onAccept]);

    return (
        <ModalBase open onDismiss={onCancel} variant="partial">
            <ModalHeader>{title}</ModalHeader>
            <ModalBody pb={u(4)}>
                <p>{message}</p>
            </ModalBody>
            <ModalFooter
                primary={
                    <Button onClick={handleAccept} isLoading={isLoading}>
                        Accept
                    </Button>
                }
                secondary={
                    <Button variant="secondary" onClick={onCancel}>
                        Dismiss
                    </Button>
                }
            ></ModalFooter>
        </ModalBase>
    );
};
